// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2097); hand-edits allowed (see docs/architecture.md)

/** `this.PEACHFUL_BONUS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_PEACHFUL_BONUS(): any {
  return {
    "p": 0.25,
    "e": 0.35,
    "a": 0.4,
    "c": 0.5,
    "h": 0.15,
    "f": 0.3,
    "u": 0,
    "l": 0.4
  };
}
